export default "__VITE_ASSET__8Fz6ssHW__"